import { SpotType } from "~/generated/graphql.types";

export const spotTypeJapanese = new Map([
  [SpotType.Start, "スタート"],
  [SpotType.Destination, "ゴール"],
  [SpotType.Waypoint, "経由地"],
  [SpotType.OptionalWaypoint, "オプションの経由地"],
  [SpotType.Narration, "音声スポット"],
  [SpotType.SubaruMoment, "スバルモーメント"],
]);
